import { useCallback } from "react";
import { useFetch } from "./useFetch"; // Adjust import path
import packageJson from "../../package.json";

export const usePostEvent = (user) => {
  const { postData, isPending, isSuccess, error } = useFetch("event", "POST");

  const logEvent = useCallback(
    (eventId, clubID) => {
      if (!user) return;
      let slug = "loyaltypro"
      switch (clubID) {
      case "038":
        slug = "cranleigh";
        break;
      default:
        slug = "loyaltypro";
    }

      postData({
        slug: slug,
        event: eventId,
        version: packageJson.version,
        OS: "Web",
        userGuid: user,
        DeviceGuid: "00000000-0000-0000-0000-000000000000",
      });
    },
    [user, postData]
  );

  return { logEvent, isPending, isSuccess, error };
};